import { render, staticRenderFns } from "./DeliveryCompleteView.vue?vue&type=template&id=8f32638e&lang=pug"
import script from "./DeliveryCompleteView.vue?vue&type=script&lang=js"
export * from "./DeliveryCompleteView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports